import React, { useEffect, useState } from "react"
import { AppContext } from "@lightspeed-invoicing/core-client/frontend"
import Select from "react-select"

import { mapUserSelectOptionFromElasticSearch, mapValueAndLabelFromSelectedOption } from "../../../utils"
import { UserSelectProps } from "../../types/select/userSelect"
import { SelectOption } from "../../types"

export function UserSelect(props: UserSelectProps) {
    const [options, setOptions] = useState<Array<SelectOption<string>>>([])
    const filter =
        props.filter ||
        function () {
            return true
        }

    const handleChange = (selectedOption: Array<SelectOption<string>> | SelectOption<string>) => {
        const { value, label } = mapValueAndLabelFromSelectedOption(selectedOption, props.multi ?? false)
        props.onChange(value, label)
    }



    useEffect(() => {
        const abortController = new AbortController()
        AppContext.getApiClient()
            .get("/users")
            .then(res => {
                if (res.data) {
                    setOptions(mapUserSelectOptionFromElasticSearch(res.data, filter))
                }
            })
        return () => {
            abortController.abort()
        }
    }, [])

    return (
        <Select
            disabled={props.disabled ?? false}
            multi={props.multi ?? false}
            name={props.name}
            placeholder={props.placeholder ?? ""}
            value={props.value}
            onChange={handleChange}
            onBlur={
                props.onBlur ||
                function () {
                    return null
                }
            }
            options={options ?? []}
            required={props.required ?? false}
            style={props.style}
            clearable={props.clearable ? props.clearable : true}
        />
    )
}


// WEBPACK FOOTER //
// ./src/common/user/selection/selection.component.tsx